import Api from "../axios"

export const postReadPolicy= async ({id})=>{
    return await Api.post('/read_policy',{
        policyId: id
    })
} 